<template>
	<side-window :tabs="tabs" :active="active" class="template" title="Skabelon" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'general'">
					<select-view label="Type" v-model="entity.type" :options="[
						{
							label: 'Tilbud',
							value: 'quote'
						},
						{
							label: 'Ordre',
							value: 'order'
						}
					]" />
				</div>
				<div v-show="active == 'general'">
					<string-view label="Label" v-model="entity.label" />
				</div>
				<div v-show="active == 'general'">
					<div class="side-window__heading small">
						Vis resume
						<switch-view v-model="entity.incl_summary" />
					</div>
					<div class="side-window__heading small">
						Vis pris
						<switch-view v-model="entity.incl_price" />
					</div>
				</div>
				<div v-show="active == 'general'">
					<text-view label="Tekst (først i dokumentet)" v-model="entity.desc" :height="180" />
				</div>
				<div v-show="active == 'general'">
					<text-view label="Prisbeskrivelse (efter pris)" v-model="entity.ps" :height="180" />
					<text-view label="Evt andet (standard tekst)" v-model="entity.other" :height="180" />
					<div class="side-window__heading">
						Redigerbar
						<switch-view v-model="entity.ps_editable" />
					</div>
				</div>
				<div v-show="active == 'general'">
					<text-view label="Efterskrift (sidst i dokumentet)" v-model="entity.extra" :height="180" />
				</div>
				<div v-show="active == 'general'">
					<text-view label="Opbevaring" v-model="entity.storage" :height="180" />
				</div>
				<div v-show="active == 'general'">
					<text-view label="E-mail" v-model="entity.email" :height="180" />
				</div>
				<div v-show="active == 'details'">
					<string-view label="Titel" v-model="entity.details.title" />
					<string-view label="Undertitel" v-model="entity.details.subtitle" />
				</div>
				<div v-show="active == 'details'">
					<string-view label="Firma" v-model="entity.details.company" />
					<string-view label="Adresse" v-model="entity.details.address" />
					<string-view label="Postnr" v-model="entity.details.zip" />
					<string-view label="By" v-model="entity.details.city" />
					<string-view label="CVR" v-model="entity.details.vat" />
				</div>
				<div v-show="active == 'details'">	
					<string-view label="Hjemmeside" v-model="entity.details.website" />
					<string-view label="E-mail" v-model="entity.details.email" />
					<string-view label="Telefon" v-model="entity.details.phone" />
				</div>
				<div v-show="active == 'details'">
					<string-view label="Bank" v-model="entity.details.bank" />
					<string-view label="Betalingsmetoder" v-model="entity.details.payment" />
				</div>
				<div v-show="active == 'details'">
					<string-view label="Sidefod" v-model="entity.details.footer" />
				</div>
				<div v-show="active == 'incl'">
					<text-view label="Muligheder" v-model="entity.incl" :height="180" />
				</div>
				<div v-show="active == 'files'">
					<file-list-view v-model="entity.files" />
				</div>
				<div v-show="active == 'translation'">
					<string-view label="Bank" 				v-model="entity.trans.bank" />
					<string-view label="Betaling" 			v-model="entity.trans.payment" />
					<string-view label="Side" 				v-model="entity.trans.page" />
					<string-view label="Beskrivelse"		v-model="entity.trans.description" />
					<string-view label="Antal"				v-model="entity.trans.qty" />
					<string-view label="Enhed"				v-model="entity.trans.unit" />
					<string-view label="Moms"				v-model="entity.trans.vat" />
					<string-view label="Rabat"				v-model="entity.trans.discount" />
					<string-view label="Tillæg"				v-model="entity.trans.sur" />

					<string-view label="Pris"				v-model="entity.trans.price" />
					<string-view label="Subtotal"			v-model="entity.trans.subtotal" />
					<string-view label="Total"				v-model="entity.trans.total" />
					<string-view label="Timepris"			v-model="entity.trans.hour" />
					<string-view label="Variable priser"	v-model="entity.trans.var" />
					<string-view label="Pris per enhed"		v-model="entity.trans.ppu" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';

	import OrderModel from '../model/Order'

	import merge from '../functions/merge'

	export default {
		data: function () {
			return {
				entity: {},
				active: 'general',
			};
		},
		watch: {
			from(newVal) {
				this.to = newVal;
			}
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'general',
						label: 'Generelt'
					},
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'incl',
						label: 'Inkluderet'
					},
					{
						name: 'files',
						label: 'Filer'
					},
					{
						name: 'translation',
						label: 'Oversættelse'
					}
				];
			}
		},
		props: {
			id: Number,
			submit: {
				type: Function,
				default: function (entity) { return true; }
			},
			value: {
				type: Object,
				default() {
					return merge({}, OrderModel.entity());
				}
			}
		},
		methods: {
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				//
				this.submit(this.entity);
			}
		},
		mounted: function() {
			var self = this;

			this.entity = merge({}, this.value);

			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
				});*/

			
		}
	}
</script>

<style lang="scss">
	
</style>
